import _regeneratorRuntime from 'babel-runtime/regenerator';

var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

import { callAPI, BASE_URL } from '../../middleware';
import { getAuthToken } from 'roy-morgan-auth';

export var MENU_REQUEST = 'MENU_REQUEST';
export var MENU_SUCCESS = 'MENU_SUCCESS';
export var MENU_FAILURE = 'MENU_FAILURE';

var loadMenuRequest = function loadMenuRequest() {
  return {
    type: MENU_REQUEST
  };
};

var loadMenuSuccess = function loadMenuSuccess(menu) {
  return {
    type: MENU_SUCCESS,
    payload: menu
  };
};

var loadMenuFailure = function loadMenuFailure(error) {
  return {
    type: MENU_FAILURE,
    error: error
  };
};

export var loadMenu = function loadMenu(slug) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var customHeaders, token, response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              customHeaders = {};
              token = getAuthToken();

              dispatch(loadMenuRequest());
              _context.next = 6;
              return callAPI({
                method: 'GET',
                targetUrl: BASE_URL + '/wp-json/wp-api-menus/v2/menus/' + slug,
                token: token,
                headers: customHeaders
              });

            case 6:
              response = _context.sent;

              if (!(response instanceof Error)) {
                _context.next = 9;
                break;
              }

              throw response;

            case 9:
              dispatch(loadMenuSuccess(response));
              _context.next = 15;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context['catch'](0);

              dispatch(loadMenuFailure(_context.t0));

            case 15:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 12]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};